import { createElement } from 'react';
import { string, bool, number, object, func, shape } from 'prop-types';
import { b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import _omit from 'lodash/omit';
import { formikField, reduxFormField } from '../adaptors/fields.js';
import { a as FieldWrapper, b as fieldWrapperPropTypes, c as fieldWrapperDefaultProps } from '../chunk-1195bf9a.js';
import _Textarea, { LoadingSpinner } from './styled.js';

var Textarea = function Textarea(_ref) {
  var a11yId = _ref.a11yId,
      a11yLabel = _ref.a11yLabel,
      isLoading = _ref.isLoading,
      isRequired = _ref.isRequired,
      size = _ref.size,
      state = _ref.state,
      textareaRef = _ref.textareaRef,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yId", "a11yLabel", "isLoading", "isRequired", "size", "state", "textareaRef"]);

  return createElement(Box, {
    relative: true
  }, createElement(_Textarea, _extends({
    use: "textarea",
    "aria-invalid": state === 'danger',
    "aria-label": a11yLabel,
    "aria-required": isRequired,
    id: a11yId,
    elementRef: textareaRef,
    styledSize: size,
    state: state
  }, props)), isLoading && createElement(LoadingSpinner, {
    color: "text"
  }));
};

Textarea.Formik = formikField(Textarea);
Textarea.ReduxForm = reduxFormField(Textarea);
var textareaPropTypes = {
  a11yId: string,
  a11yLabel: string,
  autoComplete: string,
  autoFocus: bool,
  className: string,
  defaultValue: string,
  disabled: bool,
  isFullWidth: bool,
  isLoading: bool,
  isRequired: bool,
  name: string,
  size: string,
  maxLength: number,
  minLength: number,
  pattern: string,
  placeholder: string,
  readOnly: bool,
  rows: number,
  spellCheck: bool,
  state: string,
  textareaRef: object,
  value: string,
  onBlur: func,
  onChange: func,
  onFocus: func
};
Textarea.propTypes = textareaPropTypes;
var textareaDefaultProps = {
  a11yId: undefined,
  a11yLabel: undefined,
  autoComplete: undefined,
  autoFocus: false,
  className: undefined,
  defaultValue: undefined,
  disabled: false,
  isFullWidth: false,
  isLoading: false,
  isRequired: false,
  maxLength: undefined,
  minLength: undefined,
  name: undefined,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined,
  pattern: undefined,
  placeholder: undefined,
  readOnly: undefined,
  rows: 3,
  spellCheck: undefined,
  size: 'default',
  state: undefined,
  textareaRef: undefined,
  value: undefined
};
Textarea.defaultProps = textareaDefaultProps; // @ts-ignore

var TextareaField = function TextareaField(_ref) {
  var a11yId = _ref.a11yId,
      a11yLabel = _ref.a11yLabel,
      autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      defaultValue = _ref.defaultValue,
      description = _ref.description,
      disabled = _ref.disabled,
      hint = _ref.hint,
      isFullWidth = _ref.isFullWidth,
      isLoading = _ref.isLoading,
      isOptional = _ref.isOptional,
      isRequired = _ref.isRequired,
      label = _ref.label,
      name = _ref.name,
      maxLength = _ref.maxLength,
      minLength = _ref.minLength,
      pattern = _ref.pattern,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      rows = _ref.rows,
      spellCheck = _ref.spellCheck,
      size = _ref.size,
      state = _ref.state,
      textareaProps = _ref.textareaProps,
      textareaRef = _ref.textareaRef,
      validationText = _ref.validationText,
      value = _ref.value,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yId", "a11yLabel", "autoComplete", "autoFocus", "defaultValue", "description", "disabled", "hint", "isFullWidth", "isLoading", "isOptional", "isRequired", "label", "name", "maxLength", "minLength", "pattern", "placeholder", "readOnly", "rows", "spellCheck", "size", "state", "textareaProps", "textareaRef", "validationText", "value", "onBlur", "onChange", "onFocus"]);

  return createElement(FieldWrapper, _extends({
    a11yId: a11yId,
    description: description,
    hint: hint,
    isOptional: isOptional,
    isRequired: isRequired,
    label: label,
    state: state,
    validationText: validationText
  }, props), function (_ref2) {
    var elementProps = _ref2.elementProps;
    return createElement(Textarea, _extends({
      a11yId: a11yId,
      a11yLabel: a11yLabel,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      defaultValue: defaultValue,
      disabled: disabled,
      isFullWidth: isFullWidth,
      isLoading: isLoading,
      isRequired: isRequired,
      name: name,
      size: size,
      maxLength: maxLength,
      minLength: minLength,
      pattern: pattern,
      placeholder: placeholder,
      readOnly: readOnly,
      rows: rows,
      spellCheck: spellCheck,
      state: state,
      textareaRef: textareaRef,
      value: value,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus
    }, elementProps, textareaProps));
  });
};

TextareaField.Formik = formikField(TextareaField, {
  hasFieldWrapper: true
});
TextareaField.ReduxForm = reduxFormField(TextareaField, {
  hasFieldWrapper: true
});

var textareaFieldPropTypes = _objectSpread({
  textareaProps: shape(textareaPropTypes)
}, _omit(fieldWrapperPropTypes, 'children'), textareaPropTypes);

TextareaField.propTypes = textareaFieldPropTypes;

var textareaFieldDefaultProps = _objectSpread({
  textareaProps: {}
}, fieldWrapperDefaultProps, textareaDefaultProps);

TextareaField.defaultProps = textareaFieldDefaultProps; // @ts-ignore

var C = TextareaField;
export { Textarea as a, TextareaField as b, textareaFieldPropTypes as c, textareaFieldDefaultProps as d, C as e, textareaPropTypes as f, textareaDefaultProps as g };